import { render, staticRenderFns } from "./PreviewQuestionsAnswersModule.vue?vue&type=template&id=bff9cad8&scoped=true"
import script from "./PreviewQuestionsAnswersModule.vue?vue&type=script&lang=js"
export * from "./PreviewQuestionsAnswersModule.vue?vue&type=script&lang=js"
import style0 from "./PreviewQuestionsAnswersModule.vue?vue&type=style&index=0&id=bff9cad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff9cad8",
  null
  
)

export default component.exports